<ng-container *ngIf="(sitename | formatSitename) === 'Myessaywriter.ai' ||(sitename | formatSitename) === 'Perfectessaywriter.ai' || (sitename | formatSitename) === 'perfectessaywriter.ai' || (sitename | formatSitename) === 'Essayservice.ai' || (sitename | formatSitename) === 'Freeessaywriter.ai' ||(sitename | formatSitename) === 'Myperfectpaper.net' ; else otherSite">
  <p><strong>Hi {{ username }},</strong></p>
  <p>
    Thanks for reaching out! I just got your request, and one of our team
    members will give you a quick call within the next 15 minutes.
  </p>

  <p>
    If you’d rather chat over email, just hit reply — I’d love to help you
    directly.
  </p>

  <p>Looking forward to hearing from you,</p>
  <strong>Kate</strong><br />
  <br />
  <hr
    style="
      width: 100%;
      border: 0;
      height: 1px;
      background: rgba(0, 123, 255, 0.2);
    "
  />
  <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px">
    <tr>
      <td width="100" align="left" valign="top" style="padding-right: 10px">
        <img
          src="https://backend.skyscrapersnow.com/images/kate.avif"
          alt="kate A."
          width="97"
          height="124"
          style="border-radius: 8px; display: block"
        />
      </td>
      <td
        align="left"
        valign="top"
        style="font-family: Arial, sans-serif; font-size: 14px; color: #333"
      >
        <img
          src="https://backend.skyscrapersnow.com/images/kate_sign.png"
          alt="Kate A Signature"
          style="
            max-width: 82px;
            max-height: 34px;
            display: block;
            margin-bottom: 5px;
          "
        />
        <p
          style="
            font-weight: 500;
            font-size: 18px;
            color: #000000;

            text-align: left;
            margin: 0;
          "
        >
          kate A.
        </p>
        <p
          style="
            margin: 7px 0;
            color: #767e8c;
            font-size: 13px;
            text-align: left;
          "
        >
          Client Support
        </p>
        <table cellpadding="0" cellspacing="0" border="0">
          <tr>
            <td valign="middle" style="padding: 0px">
              <img
                src="https://backend.skyscrapersnow.com/images/globe.png"
                alt="Website"
                width="15"
                height="15"
                style="display: block"
              />
            </td>
            <td
              valign="middle"
              style="font-size: 13px; color: #767e8c; padding: 0px 0px 0px 5px"
            >
              <a
                href="https://'.$site_link_clean.'"
                style="color: #767e8c; text-decoration: none"
                >{{ sitename }}</a
              >
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</ng-container>

<ng-template #otherSite>
  <p><strong>Hi {{ username }},</strong></p>

  <p>
    Thanks for stopping by {{ sitename | formatSitename }} — here’s your
    <strong>mystery gift</strong>, as promised:
  </p>

  <p>
    🎓
    <strong>
      Use code <strong style="color: green">STUDENT15</strong> on checkout to
      get 15% off your first order.</strong
    >
  </p>

  <p>
    Whether it's an essay, research paper, or any assignment, this discount is
    our way of saying welcome — and helping you stress less this semester.
  </p>

  <p>We’ve got your back.</p>

  <p>
    Thanks again,<br />
    <strong>The {{ sitename | formatSitename }} Team</strong><br />
    <a href="{{sitename}}"
      ><strong>https://{{ sitename }}</strong></a
    >
  </p>
  <br />
  <hr
    style="
      width: 100%;
      border: 0;
      height: 1px;
      background: rgba(0, 123, 255, 0.2);
    "
  />
</ng-template>
